// @generated by protobuf-ts 2.11.1 with parameter long_type_string,generate_dependencies,output_legacy_commonjs
// @generated from protobuf file "sennotech/base/captcha/mobile_captcha.proto" (package "base.captcha", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { StringValue } from "../../google/protobuf/wrappers";
/**
 * @generated from protobuf message base.captcha.GenerateRequest
 */
export interface GenerateRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: base.captcha.TemplateType templateType = 3
     */
    templateType: TemplateType;
}
/**
 * @generated from protobuf message base.captcha.GenerateResponse
 */
export interface GenerateResponse {
    /**
     * @generated from protobuf field: bool done = 1
     */
    done: boolean;
    /**
     * @generated from protobuf field: google.protobuf.StringValue captcha = 2
     */
    captcha?: StringValue; // 仅供开发测试，正式发布后不会返回。
}
/**
 * @generated from protobuf message base.captcha.CheckRequest
 */
export interface CheckRequest {
    /**
     * @generated from protobuf field: string countryCode = 1
     */
    countryCode: string;
    /**
     * @generated from protobuf field: string mobileNumber = 2
     */
    mobileNumber: string;
    /**
     * @generated from protobuf field: string captcha = 3
     */
    captcha: string;
}
/**
 * @generated from protobuf message base.captcha.CheckResponse
 */
export interface CheckResponse {
    /**
     * @generated from protobuf field: bool isCorrect = 1
     */
    isCorrect: boolean;
}
/**
 * @generated from protobuf enum base.captcha.TemplateType
 */
export enum TemplateType {
    /**
     * 注册模版
     *
     * @generated from protobuf enum value: REGISTER = 0;
     */
    REGISTER = 0,
    /**
     * 一般验证码模版
     *
     * @generated from protobuf enum value: GENERAL = 1;
     */
    GENERAL = 1
}
// @generated message type with reflection information, may provide speed optimized methods
class GenerateRequest$Type extends MessageType<GenerateRequest> {
    constructor() {
        super("base.captcha.GenerateRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "templateType", kind: "enum", T: () => ["base.captcha.TemplateType", TemplateType] }
        ]);
    }
    create(value?: PartialMessage<GenerateRequest>): GenerateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        message.templateType = 0;
        if (value !== undefined)
            reflectionMergePartial<GenerateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateRequest): GenerateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* base.captcha.TemplateType templateType */ 3:
                    message.templateType = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* base.captcha.TemplateType templateType = 3; */
        if (message.templateType !== 0)
            writer.tag(3, WireType.Varint).int32(message.templateType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.captcha.GenerateRequest
 */
export const GenerateRequest = new GenerateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GenerateResponse$Type extends MessageType<GenerateResponse> {
    constructor() {
        super("base.captcha.GenerateResponse", [
            { no: 1, name: "done", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "captcha", kind: "message", T: () => StringValue }
        ]);
    }
    create(value?: PartialMessage<GenerateResponse>): GenerateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.done = false;
        if (value !== undefined)
            reflectionMergePartial<GenerateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GenerateResponse): GenerateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool done */ 1:
                    message.done = reader.bool();
                    break;
                case /* google.protobuf.StringValue captcha */ 2:
                    message.captcha = StringValue.internalBinaryRead(reader, reader.uint32(), options, message.captcha);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GenerateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool done = 1; */
        if (message.done !== false)
            writer.tag(1, WireType.Varint).bool(message.done);
        /* google.protobuf.StringValue captcha = 2; */
        if (message.captcha)
            StringValue.internalBinaryWrite(message.captcha, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.captcha.GenerateResponse
 */
export const GenerateResponse = new GenerateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckRequest$Type extends MessageType<CheckRequest> {
    constructor() {
        super("base.captcha.CheckRequest", [
            { no: 1, name: "countryCode", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "mobileNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "captcha", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<CheckRequest>): CheckRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.countryCode = "";
        message.mobileNumber = "";
        message.captcha = "";
        if (value !== undefined)
            reflectionMergePartial<CheckRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckRequest): CheckRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string countryCode */ 1:
                    message.countryCode = reader.string();
                    break;
                case /* string mobileNumber */ 2:
                    message.mobileNumber = reader.string();
                    break;
                case /* string captcha */ 3:
                    message.captcha = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string countryCode = 1; */
        if (message.countryCode !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.countryCode);
        /* string mobileNumber = 2; */
        if (message.mobileNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.mobileNumber);
        /* string captcha = 3; */
        if (message.captcha !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.captcha);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.captcha.CheckRequest
 */
export const CheckRequest = new CheckRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CheckResponse$Type extends MessageType<CheckResponse> {
    constructor() {
        super("base.captcha.CheckResponse", [
            { no: 1, name: "isCorrect", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<CheckResponse>): CheckResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.isCorrect = false;
        if (value !== undefined)
            reflectionMergePartial<CheckResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: CheckResponse): CheckResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool isCorrect */ 1:
                    message.isCorrect = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: CheckResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool isCorrect = 1; */
        if (message.isCorrect !== false)
            writer.tag(1, WireType.Varint).bool(message.isCorrect);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message base.captcha.CheckResponse
 */
export const CheckResponse = new CheckResponse$Type();
/**
 * @generated ServiceType for protobuf service base.captcha.MobileCaptchaService
 */
export const MobileCaptchaService = new ServiceType("base.captcha.MobileCaptchaService", [
    { name: "Generate", options: { "google.api.http": { post: "/base.captcha.MobileCaptchaService/Generate", body: "*" } }, I: GenerateRequest, O: GenerateResponse },
    { name: "Check", options: { "google.api.http": { post: "/base.captcha.MobileCaptchaService/Check", body: "*" } }, I: CheckRequest, O: CheckResponse }
]);
